import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.css']
})
export class ProjectViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
